<template>
  <div class="popup" :class="{ 'slide-up': show, 'slide-down': !show }">
    <img :src="img">
    <div class="popup__text">
      View our free <strong>Bionic VoIP brochure</strong> while we review your
      details
      <div class="popup-button__yes" @click="openLink">
        Yes please
      </div>
      <div class="popup-button__no" @click="show = false">
        Not right now
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Popup',
  data () {
    return {
      img: require('@/assets/icons/popup-book.svg'),
      show: false
    }
  },
  mounted () {
    setTimeout(() => {
      this.show = true
    }, 1000)
  },
  methods: {
    openLink () {
      this.show = false
      window.open('./voip.pdf', '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.popup {
  background: $callback-popup-colour;
  border-radius: 10px 10px 0 0;
  padding: $spacing-16;
  display: flex;
  color: $white;
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 1010;
  width: 100%;

  @media (min-width: 800px) {
    width: 406px;
    padding: $spacing-32;
  }

  &__text {
    font-size: 14px;

    @media (min-width: 800px) {
      font-size: 20px;
    }
  }

  img {
    margin-right: 20px;
    width: 90px;

    @media (min-width: 800px) {
      width: 130px;
    }
  }

  &-button {
    font-size: 14px;
    cursor: pointer;
    font-weight: bold;
    &__yes {
      @extend .popup-button;
      width: 175px;
      border-radius: 28px;
      background-color: $white;
      padding-top: $spacing-8;
      padding-bottom: $spacing-8;
      color: $callback-popup-colour;
      margin: $spacing-20 auto 10px;

      @media (min-width: 800px) {
        width: 194px;
      }
    }

    &__no {
      @extend .popup-button;
    }
  }
}
.slide-up,
.slide-down {
  overflow: hidden;
}
.slide-up,
.slide-down {
  transition: 0.4s ease-in-out;
}

.slide-up {
  transform: translateY(0);
}
.slide-down {
  transform: translateY(100%);
}
</style>
